import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';

export const TOWER_MATRIX_SIZE = ['2x3', '3x6', '4x9', '5x12', '6x15'];
export const TOWER_GAME_ID = 109;

export const MAP_TYPES = {
  '2x3': 0,
  '3x6': 1,
  '4x9': 2,
  '5x12': 3,
  '6x15': 4,
};

export const SIZES_BY_MAP_TYPES = {
  0: {
    h: 2,
    v: 3,
  },
  1: {
    h: 3,
    v: 6,
  },
  2: {
    h: 4,
    v: 9,
  },
  3: {
    h: 5,
    v: 12,
  },
  4: {
    h: 6,
    v: 15,
  },
};

export const towerSoundsName = {
  win: 'win',
  bet: 'bet',
  bomb: 'bomb',
  hover: 'hover',
  diamond: 'diamond',
  diamond1: 'diamond_1',
  diamond2: 'diamond_2',
  bgMusic: 'bg-music',
};

export const TowerBetStatus = {
  lose: 0,
  win: 1,
  onHold: 7,
};

export const TowerLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: () => <p>{userInfoStore.currencyCode}</p>,
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: () => <p>{userInfoStore.currencyCode}</p>,
  },
];

export const TowerBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: () => <p>{userInfoStore.currencyCode}</p>,
  },
  {
    title: TranslationKeys.TowerSize,
    dataKey: 'mapType',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (e) =>
      `${SIZES_BY_MAP_TYPES[e.mapType].h}x${SIZES_BY_MAP_TYPES[e.mapType].v}`,
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: () => <p>{userInfoStore.currencyCode}</p>,
  },
];

export const TOWER_RULES_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
export const TOWER_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
